export const FETCH_TASKS_START = 'FETCH_TASKS_START';
export const FETCH_TASKS_SUCCESS = 'FETCH_TASKS_SUCCESS';
export const FETCH_TASKS_FAIL = 'FETCH_TASKS_FAIL';

export const FETCH_ALL_TASKS_START = 'FETCH_ALL_TASKS_START';
export const FETCH_ALL_TASKS_SUCCESS = 'FETCH_ALL_TASKS_SUCCESS';
export const FETCH_ALL_TASKS_FAIL = 'FETCH_ALL_TASKS_FAIL';

export const FETCH_TASK_START = 'FETCH_TASK_START';
export const FETCH_TASK_SUCCESS = 'FETCH_TASK_SUCCESS';
export const FETCH_TASK_FAIL = 'FETCH_TASK_FAIL';

export const CREATE_TASK_START = 'CREATE_TASK_START';
export const CREATE_TASK_SUCCESS = 'CREATE_TASK_SUCCESS';
export const CREATE_TASK_FAIL = 'CREATE_TASK_FAIL';

export const UPDATE_TASK_START = 'UPDATE_TASK_START';
export const UPDATE_TASK_SUCCESS = 'UPDATE_TASK_SUCCESS';
export const UPDATE_TASK_FAIL = 'UPDATE_TASK_FAIL';

export const DELETE_TASK_START = 'DELETE_TASK_START';
export const DELETE_TASK_SUCCESS = 'DELETE_TASK_SUCCESS';
export const DELETE_TASK_FAIL = 'DELETE_TASK_FAIL';

export const REFRESH_TASK_LIST = 'REFRESH_TASK_LIST';

export const RESET_TASK_STORE = 'RESET_TASK_STORE';

export const LOGOUT = 'LOGOUT';

export type TaskActionTypes =
  | typeof FETCH_TASKS_START
  | typeof FETCH_TASKS_SUCCESS
  | typeof FETCH_TASKS_FAIL
  | typeof FETCH_ALL_TASKS_START
  | typeof FETCH_ALL_TASKS_SUCCESS
  | typeof FETCH_ALL_TASKS_FAIL
  | typeof FETCH_TASK_START
  | typeof FETCH_TASK_SUCCESS
  | typeof FETCH_TASK_FAIL
  | typeof CREATE_TASK_START
  | typeof CREATE_TASK_SUCCESS
  | typeof CREATE_TASK_FAIL
  | typeof UPDATE_TASK_START
  | typeof UPDATE_TASK_SUCCESS
  | typeof UPDATE_TASK_FAIL
  | typeof DELETE_TASK_START
  | typeof DELETE_TASK_SUCCESS
  | typeof DELETE_TASK_FAIL
  | typeof RESET_TASK_STORE
  | typeof REFRESH_TASK_LIST
  | typeof LOGOUT;
